import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";

import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import EmergencyBanner from "./components/EmergencyBanner";

import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import ServiceCity from "./pages/ServiceCity";
import Fleet from "./pages/Fleet";
import ServiceArea from "./pages/ServiceArea";
import CityDetail from "./pages/CityDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Resources from "./pages/Resources";
import ArticleDetail from "./pages/ArticleDetail";

function ScrollHandler() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname, location.hash]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollHandler />
          <EmergencyBanner />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/services/:slug/:citySlug" element={<ServiceCity />} />
              <Route path="/fleet" element={<Fleet />} />
              <Route path="/service-area" element={<ServiceArea />} />
              <Route path="/service-area/:slug" element={<CityDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/resources/:slug" element={<ArticleDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#141414",
              color: "#fff",
              border: "1px solid #27272a",
              borderRadius: 0,
            },
          }}
        />
      </div>
    </HelmetProvider>
  );
}

export default App;
